import { render, staticRenderFns } from "./ChatPreviewWindow.vue?vue&type=template&id=2e130764&scoped=true"
import script from "./ChatPreviewWindow.vue?vue&type=script&lang=ts"
export * from "./ChatPreviewWindow.vue?vue&type=script&lang=ts"
import style0 from "./ChatPreviewWindow.vue?vue&type=style&index=0&id=2e130764&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e130764",
  null
  
)

export default component.exports